import { createSelector } from 'reselect';
import { paramsToQueryString } from "../../Helpers/url";
import { getLocationId } from "../../Helpers/location";
import DependencyManager from "../../DependencyManager";
import { popularDataUrlPath } from "../../Constants/buyEngager";
var getPopularDataURL = createSelector(function (state) {
  return state.popularData;
}, function (state) {
  return state && state.locations && state.locations.selectedLocation;
}, function (_, _ref) {
  var attribute = _ref.attribute;
  return attribute;
}, function (_, _ref2) {
  var flow = _ref2.flow;
  return flow;
}, function (_, _ref3) {
  var category = _ref3.category;
  return category;
}, function (state) {
  return state.api && state.api.queryParam && state.api.queryParam.enableMultiLang && state.api.queryParam.lang || '';
}, function (popularData, selectedLocation, attribute, flow, category, lang) {
  var PanameraConstants = DependencyManager.getDependency('constants');
  var queryParams = Object.assign({
    locationId: getLocationId(selectedLocation),
    attribute: attribute,
    flow: flow,
    category: category,
    platform: "web-".concat(PanameraConstants.platform)
  }, lang ? {
    lang: lang
  } : {});
  var url = "".concat(popularDataUrlPath, "?").concat(paramsToQueryString(queryParams));
  return {
    popularData: popularData,
    url: url
  };
});
export var getPopularDataSelector = createSelector(getPopularDataURL, function (_ref4) {
  var popularData = _ref4.popularData,
    url = _ref4.url;
  return popularData && popularData.popularData && popularData.popularData[url];
});
export var isError = createSelector(getPopularDataURL, function (_ref5) {
  var popularData = _ref5.popularData,
    url = _ref5.url;
  return popularData && popularData.isError && popularData.isError[url];
});
export var isFetching = createSelector(getPopularDataURL, function (_ref6) {
  var popularData = _ref6.popularData,
    url = _ref6.url;
  return popularData && popularData.isFetching && popularData.isFetching[url];
});
export default {
  getPopularDataSelector: getPopularDataSelector,
  isError: isError,
  isFetching: isFetching
};